import { render, staticRenderFns } from "./FileReportsMenu.vue?vue&type=template&id=93fbca02"
import script from "./FileReportsMenu.vue?vue&type=script&lang=js"
export * from "./FileReportsMenu.vue?vue&type=script&lang=js"
import style0 from "./FileReportsMenu.vue?vue&type=style&index=0&id=93fbca02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports